import { FiLoader } from "react-icons/fi";

export default function CustomButton({
  children,
  variant = "primary",
  onClick,
  fullWidth = false,
  loading = false,
  className = "",
  type = "button",
  disabled = false,
}) {
  const base =
    "text-sm font-medium rounded-xl py-2.5 px-6 transition shadow-sm flex items-center justify-center gap-2";

  const styles = {
    primary: "bg-toucanTeal text-white hover:bg-[#00A8B4]",
    secondary:
      "border border-[#0F2F62] text-[#0F2F62] hover:bg-[#0F2F62]/10 bg-white",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={loading || disabled}
      className={`
        ${base}
        ${styles[variant]}
        ${fullWidth ? "w-full" : ""}
        ${loading ? "opacity-70 cursor-not-allowed" : ""}
        ${className}
      `}
    >
      {loading && <FiLoader className="animate-spin" />}
      <span>{children}</span>
    </button>
  );
}
